import { useMutation } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { showErrorToast } from '@hooks/showErrorToast';
import { request } from '@utils';

export const useAdminExportBatch = () => {
  return useMutation({
    mutationFn: async (batchId: string) => {
      const response = await request({
        path: `admin/export-batch/${batchId}`,
        method: 'GET',
        authenticate: true,
        responseType: 'blob',
      });

      return { data: response, batchId };
    },
    onSuccess: ({ data, batchId }) => {
      const url = window.URL.createObjectURL(new Blob([data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `batch-${batchId}.zip`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);

      toast.success('Batch export downloaded successfully');
    },
    onError: (error: any) => {
      showErrorToast(error, 'Error exporting batch');
    },
  });
};
